import axios from "axios";
import { 
    CREATE_BREED_CATEGORY,
    UPDATE_BREED_CATEGORY,
    DELETE_BREED_CATEGORY,
    FETCH_BREED_CATEGORIES,
    interceptor
} from ".";

import store from "../store";
interceptor(axios, store);

export function createBreedCategory(breedCategory) {
    return {
      type: CREATE_BREED_CATEGORY,
      payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/createBreedCategory`, breedCategory, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function updateBreedCategory(breedCategory) { 
    return {
      type: UPDATE_BREED_CATEGORY,
      payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/updateBreedCategory/${breedCategory.id}`, breedCategory, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function deleteBreedCategory(selected) {
    return {
      type: DELETE_BREED_CATEGORY,
      payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/deleteBreedCategory/${selected}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function fetchBreedCategories() {
    return {
      type: FETCH_BREED_CATEGORIES,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/getBreedCategory/`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }